import { render, staticRenderFns } from "./backToTop.vue?vue&type=template&id=23ec58a8&scoped=true&"
import script from "./backToTop.vue?vue&type=script&lang=js&"
export * from "./backToTop.vue?vue&type=script&lang=js&"
import style0 from "./backToTop.vue?vue&type=style&index=0&id=23ec58a8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec58a8",
  null
  
)

export default component.exports